import { TransactionsEnum } from '@/enums/payment.enum';

export default {
    path: '/transactions',
    component: () => import('../views/Global/GenericDashboardView.vue'),
    meta: {
        private: true,
        title: 'TRANSACTIONS',
    },
    children: [
        {
            path: 'sales',
            name: 'transactions-sales',
            component: () => import('../components/Admin/AdminTransactions/AdminTransactions.vue'),
            meta: {
                accountTypes: ['support', 'notary', 'bookkeeper'],
                type: TransactionsEnum.Sale,
            },
        },
        {
            path: 'purchase',
            name: 'transactions-purchase',
            component: () => import('../components/Admin/AdminTransactions/AdminTransactions.vue'),
            meta: {
                accountTypes: ['support', 'notary', 'bookkeeper'],
                type: TransactionsEnum.Purchase,
            },
        },
        {
            path: 'payout',
            name: 'transactions-payout',
            component: () => import('../components/Admin/AdminTransactions/AdminTransactions.vue'),
            meta: {
                accountTypes: ['support', 'notary', 'bookkeeper'],
                type: TransactionsEnum.PurchasePayout,
            },
        },
        {
            path: 'credit',
            name: 'transactions-credit',
            component: () => import('../components/Admin/AdminTransactions/AdminTransactions.vue'),
            meta: {
                accountTypes: ['support'],
                type: TransactionsEnum.Credit,
            },
        },
        {
            path: ':(.*)',
            redirect: { name: 'dashboard' },
        },
    ],
};
